import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import type { WorkOrderOtherPriceData, WorkOrderPriceData, WorkOrderPriceItem } from 'gql/graphql';
import { WorkOrderStatusEnum } from 'gql/graphql';
import { Text, Badge } from 'uikit';

import type React from 'react';
import { useMemo } from 'react';

import './WorkOrderPrice.css';

interface IWorkOrderPriceCodeCell {
    row: WorkOrderPriceData | WorkOrderOtherPriceData | WorkOrderPriceItem;
    workOrderStatus?: WorkOrderStatusEnum;
}

const ACT_PRICE_TEXT = 'Добавлено на этапе приемки';

export const WorkOrderPriceCodeCell: React.FC<IWorkOrderPriceCodeCell> = (props) => {
    const { row, workOrderStatus } = props;

    const tooltipActKC2Text = useMemo(() => {
        if ('isCreatedFromSKzS' in row && row?.isCreatedFromSKzS) {
            return <span className="textAdditions">Добавлено из СКзС</span>;
        }

        if (workOrderStatus !== WorkOrderStatusEnum.OnFormation && row?.isActKC2Price) {
            return row?.rationale?.length ? (
                <div className="styleRationale">
                    <span>{ACT_PRICE_TEXT}</span>
                    <p>{row?.rationale}</p>
                </div>
            ) : (
                <span className="textAdditions">{ACT_PRICE_TEXT}</span>
            );
        }

        return '';
    }, [row, workOrderStatus]);

    const cellContent = (
        <Text align="right" size="xs">
            {'code' in row ? row?.code : ''}
        </Text>
    );

    return tooltipActKC2Text ? (
        <div style={{ display: 'flex', width: '100%' }}>
            <ComponentWithTooltip
                tooltipText={tooltipActKC2Text}
                styles={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}
            >
                <Badge label="Д" status="success" size="s" className="styleBadge" />
            </ComponentWithTooltip>
            {cellContent}
        </div>
    ) : (
        cellContent
    );
};

WorkOrderPriceCodeCell.displayName = 'WorkOrderPriceCodeCell';
